import { useState } from "react";
import { message } from "antd";
import { useUploadFile } from "../../../../../../hooks/file";
import {
  useMessageError,
  useMessageSuccess,
} from "../../../../../../hooks/common";

interface UploadedFile {
  id: string;
  name: string;
  type: "video" | "audio";
  fileLink: string;
  file?: File;
}

export function useRecordingUpload() {
  const uploadFileHook = useUploadFile("common/r2/upload-image", true, true);
  const [uploading, setUploading] = useState(false);

  const getRecordingType = (filename: string): "video" | "audio" => {
    const ext = filename.split(".").pop()?.toLowerCase();
    return ext === "mp4" ? "video" : "audio";
  };

  const upload = async (file: File): Promise<UploadedFile | null> => {
    const formData = new FormData();
    formData.append("file", file);
    setUploading(true);

    try {
      const response = await uploadFileHook.fetch(formData);
      if (response?.url) {
        // message.success(`${file.name} uploaded successfully.`);
        return {
          id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          name: file.name,
          type: getRecordingType(file.name),
          fileLink: response.url,
          file,
        };
      }
      throw new Error("Upload failed");
    } catch (error) {
      // message.error(`${file.name} upload failed.`);
      return null;
    } finally {
      setUploading(false);
    }
  };

  useMessageSuccess([uploadFileHook], "File uploaded successfully.");
  useMessageError([uploadFileHook]);

  const uploadMultiple = async (files: File[]): Promise<UploadedFile[]> => {
    const results = await Promise.all(files.map(upload));
    return results.filter((r): r is UploadedFile => r !== null);
  };

  return { upload, uploadMultiple, uploading };
}
